<script>
import HeaderActions from './HeaderActions.vue';
import { useDarkMode } from 'widget/composables/useDarkMode';

export default {
  name: 'ChatHeaderExpanded',
  components: {
    HeaderActions,
  },
  props: {
    avatarUrl: {
      type: String,
      default: '',
    },
    introHeading: {
      type: String,
      default: '',
    },
    introBody: {
      type: String,
      default: '',
    },
    showPopoutButton: {
      type: Boolean,
      default: false,
    },
  },
  setup() {
    const { getThemeClass } = useDarkMode();
    return { getThemeClass };
  },
};
</script>

<template>
  <header
    class="header-expanded pt-6 pb-4 px-5 relative box-border w-full bg-transparent"
  >
    <div class="header-bg absolute inset-0" />

    <div
      class="relative flex items-start"
      :class="[avatarUrl ? 'justify-between' : 'justify-end']"
    >
      <img
        v-if="avatarUrl"
        class="h-12 rounded-full"
        :src="avatarUrl"
        alt="Avatar"
      />
      <HeaderActions
        :show-popout-button="showPopoutButton"
        :show-end-conversation-button="false"
      />
    </div>

    <h2
      v-dompurify-html="introHeading"
      class="mt-4 text-2xl mb-1.5 font-medium relative z-10"
      :class="getThemeClass('text-white', 'dark:text-slate-50')"
    />

    <p
      v-dompurify-html="introBody"
      class="text-base leading-normal relative z-10"
      :class="getThemeClass('text-slate-200', 'dark:text-slate-200')"
    />
  </header>
</template>

<style scoped>
/* ✅ Fundal personalizat */

.header-bg {
  background-image: url("data:image/svg+xml,<svg id='patternId' width='100%' height='100%' xmlns='http://www.w3.org/2000/svg'><defs><pattern id='a' patternUnits='userSpaceOnUse' width='180' height='180' patternTransform='scale(2) rotate(30)'><rect x='0' y='0' width='100%' height='100%' fill='%23000000ff'/><path d='M150.23 130.374c0-2.188-3.881-1.812-3.881-4.605m3.882 13.818c0-2.19-3.882-1.812-3.882-4.605m3.882-4.608c0 2.19-3.882 1.814-3.882 4.607m3.882 4.606c0 2.19-3.882 1.814-3.882 4.607m-35.991-41.154c2.19 0 1.812-3.884 4.605-3.884m-13.818 3.884c2.19 0 1.812-3.884 4.606-3.884m4.607 3.884c-2.19 0-1.812-3.884-4.605-3.884m-4.608 3.884c-2.19 0-1.812-3.884-4.605-3.884M21.05 66.402c2.19 0 1.813-3.885 4.606-3.885m-13.818 3.885c2.19 0 1.812-3.885 4.605-3.885m4.608 3.885c-2.19 0-1.814-3.885-4.607-3.885m-4.606 3.885c-2.19 0-1.814-3.885-4.607-3.885m47.994 75.119c0-2.19-3.885-1.814-3.885-4.608m3.885 13.82c0-2.19-3.885-1.813-3.885-4.606m3.885-4.606c0 2.19-3.885 1.812-3.885 4.605m3.885 4.606c0 2.19-3.885 1.814-3.885 4.607m97.826-80.36c2.19 0 1.812-3.883 4.605-3.883m-13.818 3.885c2.19 0 1.813-3.885 4.606-3.885m4.605 3.885c-2.19 0-1.81-3.885-4.605-3.885m-4.606 3.885c-2.19 0-1.812-3.885-4.605-3.885m31.852 94.213c2.19 0 1.812-3.883 4.605-3.882m-13.818 3.882c2.19 0 1.814-3.882 4.607-3.882m4.606 3.882c-2.19 0-1.812-3.882-4.605-3.882m-4.608 3.882c-2.19 0-1.812-3.883-4.605-3.883M41.406 9.465c0-2.19-3.884-1.812-3.884-4.605m3.884 13.818c0-2.19-3.884-1.812-3.884-4.606m3.884-4.607c0 2.19-3.884 1.812-3.884 4.605m3.884 4.608c0 2.19-3.884 1.812-3.884 4.607m64.386-18.083c0-2.19-3.885-1.815-3.885-4.608m3.885 13.82c0-2.19-3.885-1.812-3.885-4.607m3.885-4.605c0 2.189-3.885 1.81-3.885 4.605m3.885 4.607c0 2.19-3.885 1.812-3.885 4.605m-30.82-7.937A5.031 5.031 0 0 1 62.16 6.06a5.031 5.031 0 0 1 5.043-5.019M7.405 45.548a5.031 5.031 0 0 1 5.02-5.043 5.031 5.031 0 0 1 5.02 5.043m43.014 40.944a5.043 5.043 0 0 1 10.086 0M13.09 171.46a5.031 5.031 0 0 1-5.043-5.02 5.031 5.031 0 0 1 5.043-5.021m96.36-9.155a5.032 5.032 0 0 1 3.119 6.396 5.031 5.031 0 0 1-6.41 3.09m28.36-107.946a5.032 5.032 0 0 1-5.044-5.02 5.031 5.031 0 0 1 5.043-5.02'  stroke-linecap='square' stroke-width='1' stroke='%23302f2fff' fill='none'/><path d='M43.252 112.826h10.03v10.03h-10.03zm.504-64.041h10.03v10.032h-10.03zm71.83 126.286h10.36v10.364h-10.362zm0-180h10.36V5.435h-10.362zm41.584 48.7h10.032V53.8H157.17zM39.069 86.482l-5.759-3.317-5.76-3.32.006 6.644.003 6.65 5.754-3.33zm122.355-67.748-5.76-3.32.006 6.646.003 6.648 5.754-3.329 5.755-3.327zM35.178 148.58l-6.419 1.725-6.42 1.725 4.704 4.695 4.703 4.7 1.716-6.42zm32.26-86.787 4.704 4.695 4.703 4.698 1.716-6.42 1.716-6.425-6.419 1.727zm88.992 29.392-6.42 1.725 4.703 4.695 4.702 4.7 1.716-6.423 1.718-6.423zm-34.374 38.037-3.318 5.76-3.32 5.76 6.646-.006 6.648-.004-3.329-5.754zm40.62 10.188 6.645-.004 6.648-.003-3.327-5.756-3.328-5.755-3.318 5.76zM94.921 37.268l-3.318 5.758-3.32 5.76 6.646-.006 6.648-.003-3.327-5.755z'  stroke-linecap='square' stroke-width='1' stroke='%23302f2fff' fill='none'/><path d='m140.713 114.267 4.533-4.831m.15 4.681-4.831-4.533M57.649 35.92l4.533-4.834m.15 4.681L57.5 31.233m79.46 126.872 4.534-4.833m.15 4.681-4.833-4.533m-19.662-92.964 4.533-4.834m.15 4.683-4.833-4.533m54.627 12.015 4.533-4.833m.15 4.683-4.833-4.533M2.278 29.303l4.535-4.833m.15 4.681-4.835-4.533m2.26 119.69 4.535-4.833m.15 4.681-4.834-4.533M63.2 105.456l4.534-4.833m.15 4.683-4.833-4.534m67.392-9.386 8.037-8.037M8.406 10.08l8.04-8.038m58.495 147.46 8.037-8.038m-37.222 29.998H57.12m55.914-143.766h11.367m50.037 52.838h11.367m-191.367 0H5.806m106.38 32.845h11.366M46.146 67.925l5.907 9.71'  stroke-linecap='square' stroke-width='1' stroke='%23302f2fff' fill='none'/><path d='M168.72 180.021a5.043 5.043 0 0 1-5.043 5.043 5.043 5.043 0 0 1-5.043-5.043 5.043 5.043 0 0 1 5.043-5.043 5.043 5.043 0 0 1 5.043 5.043zm0-180a5.043 5.043 0 0 1-5.043 5.043 5.043 5.043 0 0 1-5.043-5.043 5.043 5.043 0 0 1 5.043-5.043A5.043 5.043 0 0 1 168.72.021zm-80.538 118.63a5.043 5.043 0 0 1-5.043 5.042 5.043 5.043 0 0 1-5.043-5.043 5.043 5.043 0 0 1 5.043-5.043 5.043 5.043 0 0 1 5.043 5.043zm-72.57-.23a5.043 5.043 0 0 1-5.043 5.043 5.043 5.043 0 0 1-5.043-5.043 5.043 5.043 0 0 1 5.043-5.043 5.043 5.043 0 0 1 5.043 5.043Zm68.39-95.77a5.043 5.043 0 0 1-5.042 5.044 5.043 5.043 0 0 1-5.043-5.043 5.043 5.043 0 0 1 5.043-5.043 5.043 5.043 0 0 1 5.043 5.043zm25.48 56.276a5.043 5.043 0 0 1-5.042 5.043 5.043 5.043 0 0 1-5.044-5.043 5.043 5.043 0 0 1 5.043-5.041 5.043 5.043 0 0 1 5.041 5.041zm-22.26 92.556a5.043 5.043 0 0 1-5.045 5.043 5.043 5.043 0 0 1-5.043-5.043 5.043 5.043 0 0 1 5.043-5.043 5.043 5.043 0 0 1 5.045 5.043zm87.142-61.77a1.986 1.986 0 1 1-2.115-3.36 1.986 1.986 0 0 1 2.115 3.36zm-28.059-70.765a1.986 1.986 0 1 1-2.115-3.36 1.986 1.986 0 0 1 2.115 3.36zm-109.258.987a1.985 1.985 0 1 1-2.115-3.36 1.985 1.985 0 0 1 2.115 3.36zm-20.352 62.52a1.986 1.986 0 1 1-2.115-3.362 1.985 1.985 0 0 1 2.115 3.36zM88.28 85.65a1.985 1.985 0 1 1-2.115-3.36 1.985 1.985 0 0 1 2.115 3.36zm15.65 54.638a1.985 1.985 0 1 1-2.114-3.36 1.985 1.985 0 0 1 2.115 3.36z'  stroke-linecap='square' stroke-width='1' stroke='%23302f2fff' fill='none'/></pattern></defs><rect width='800%' height='800%' transform='translate(-342,0)' fill='url(%23a)'/></svg>") !important;
  background-size: cover !important;
  background-position: center !important;
  background-repeat: no-repeat !important;
  min-height: 190px !important;
  border-radius: 10px 10px 0 0 !important;
  filter: brightness(0.95);
}

/* ✅ Gradient pentru tranziție spre alb în partea de jos */
.header-bg::after {
  content: '' !important;
  position: absolute !important;
  bottom: 0 !important;
  left: 0 !important;
  width: 100% !important;
  height: 30px !important;
  background: linear-gradient(
    to bottom,
    rgba(255, 255, 255, 0) 0%,
    rgba(255, 255, 255, 0.4) 30%,
    rgba(255, 255, 255, 1) 100%
  ) !important;
  pointer-events: none !important;
}

/* ✅ Dacă Chatwoot e în Dark Mode */
.dark .header-bg::after {
  background: linear-gradient(
    to bottom,
    rgba(0, 0, 0, 0) 0%,
    rgba(15, 15, 15, 1) 100%
  ) !important;
}
</style>
